export function IconIntegrity() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 2L20 6V12C20 17 16.5 20.5 12 22C7.5 20.5 4 17 4 12V6L12 2Z"
        stroke="#F5B400"
        strokeWidth="2"
      />
      <path d="M9 12L11 14L15 10" stroke="#F5B400" strokeWidth="2" />
    </svg>
  )
}

export function IconQuality() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="10" r="7" stroke="#F5B400" strokeWidth="2" />
      <path d="M8 17L12 21L16 17" stroke="#F5B400" strokeWidth="2" strokeLinejoin="round" />
      <path d="M9.5 10.5L11 12L14.5 8.5" stroke="#F5B400" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}

export function IconReliability() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M8 12L11 15L13 13L16 16L20 12" stroke="#F5B400" strokeWidth="2" />
      <path d="M4 8L8 12M20 8L16 12" stroke="#F5B400" strokeWidth="2" />
    </svg>
  )
}

export function IconPartnership() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="8" cy="8" r="3" stroke="#F5B400" strokeWidth="2" />
      <circle cx="16" cy="8" r="3" stroke="#F5B400" strokeWidth="2" />
      <path d="M4 20C4 16.5 6.5 14 10 14" stroke="#F5B400" strokeWidth="2" />
      <path d="M20 20C20 16.5 17.5 14 14 14" stroke="#F5B400" strokeWidth="2" />
    </svg>
  )
}

export function IconExcellence() {
  return (
    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M4 18L10 12L14 16L20 8" stroke="#F5B400" strokeWidth="2" />
      <path d="M16 8H20V12" stroke="#F5B400" strokeWidth="2" />
    </svg>
  )
}
